<template>
	<div class="privacy-policy">
		<v-app-bar dense flat color="transparent" class="free-header" elevation="0">
			<v-btn icon text @click="$router.back()" aria-label="Volver">
				<v-icon>mdi-arrow-left</v-icon>
			</v-btn>
			<v-spacer />
			<img :src="require('../../assets/Svg/logoH.svg')" alt="LAOT" class="laot-logo" />
		</v-app-bar>
		<div class="container">
			<header class="policy-header">
				<h1>Política de Privacidad</h1>
				<p class="updated">Última actualización: 20 de julio de 2026</p>
			</header>

			<section class="section" id="responsable">
				<h2>1. Responsable del tratamiento</h2>
				<p><strong>LAOT.CL PANEL DE CONTROL SpA</strong>, RUT <strong>77.135.065-8</strong>, domicilio en MANUEL OLEGARIO SOTO, EL OLIVAR 199, RANCAGUA, Región del Libertador General Bernardo O'Higgins.</p>
				<p><strong>Contacto para datos personales:</strong> <a href="mailto:mcereceda@laot.cl">mcereceda@laot.cl</a> · <strong>Responsable de datos:</strong> Cristian Neira.</p>
				<p class="muted">Sobre nuestro rol: LaOT es una plataforma de gestión de proyectos. En la mayoría de los flujos actamos como <strong>encargado del tratamiento</strong> por cuenta de la empresa-cliente que contrata el servicio. Para los datos de facturación y soporte propios, actuamos como <strong>responsable</strong>.</p>
			</section>

			<section class="section" id="datos">
				<h2>2. Qué datos tratamos</h2>
				<div class="table-wrap">
					<table class="md-table">
						<thead>
							<tr>
								<th>Categoría</th>
								<th>Datos</th>
								<th>Quién los entrega</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Cuenta de usuario</td>
								<td>Nombre, correo electrónico, contraseña (almacenada con hash bcrypt), teléfono, dirección, foto de perfil</td>
								<td>El propio usuario o la empresa-cliente</td>
							</tr>
							<tr>
								<td>Proyecto</td>
								<td>Nombre del proyecto, dirección, coordenadas geográficas (lat/lng), documentos adjuntos, comentarios</td>
								<td>La empresa-cliente y sus usuarios</td>
							</tr>
							<tr>
								<td>Comunicaciones</td>
								<td>Preferencias de notificación, correos enviados a través de la plataforma</td>
								<td>El usuario</td>
							</tr>
							<tr>
								<td>Reuniones</td>
								<td>Lugar/dirección de reunión, participantes (nombre y correo), fecha</td>
								<td>El usuario</td>
							</tr>
							<tr>
								<td>Firma electrónica</td>
								<td>PIN de firma (almacenado con hash bcrypt)</td>
								<td>El usuario</td>
							</tr>
							<tr>
								<td>Facturación</td>
								<td>Nombre y RUT de empresa-cliente, datos de pago</td>
								<td>La empresa-cliente</td>
							</tr>
						</tbody>
					</table>
				</div>
				<p><strong>No tratamos datos sensibles</strong> (salud, biométricos, origen étnico, opiniones políticas, datos de menores de edad) como parte del servicio estándar.</p>
			</section>

			<section class="section" id="finalidad">
				<h2>3. Finalidad y base de licitud</h2>
				<div class="table-wrap">
					<table class="md-table">
						<thead>
							<tr><th>Finalidad</th><th>Base de licitud</th></tr>
						</thead>
						<tbody>
							<tr><td>Prestación del servicio de gestión de proyectos / cuenta de usuario</td><td>Ejecución de contrato (Art. 13 lit. b, Ley 21.719)</td></tr>
							<tr><td>Notificaciones y comunicaciones relacionadas con el servicio</td><td>Ejecución de contrato / interés legítimo</td></tr>
							<tr><td>Facturación y cumplimiento tributario</td><td>Obligación legal (Código Tributario)</td></tr>
							<tr><td>Seguridad, calidad del servicio y logs de errores</td><td>Interés legítimo del responsable/encargado</td></tr>
							<tr><td>Firma electrónica de documentos dentro de la plataforma</td><td>Ejecución de contrato</td></tr>
						</tbody>
					</table>
				</div>
			</section>

			<section class="section" id="compartimos">
				<h2>4. Con quién compartimos los datos</h2>
				<p>Usamos los siguientes <strong>proveedores que actúan como sub-encargados</strong>:</p>
				<div class="table-wrap">
					<table class="md-table">
						<thead><tr><th>Proveedor</th><th>País</th><th>Servicio</th><th>Mecanismo de transferencia</th></tr></thead>
						<tbody>
							<tr><td>Amazon Web Services (AWS)</td><td>EE.UU.</td><td>Almacenamiento de archivos (S3), correo (SES)</td><td>Cláusulas Contractuales Modelo (Min. Economía, D.O. 19-12-2025)</td></tr>
							<tr><td>Google LLC (Firebase)</td><td>EE.UU.</td><td>Notificaciones push y autenticación</td><td>Cláusulas Contractuales Modelo</td></tr>
							<tr><td>Mailgun / Sinch Email</td><td>EE.UU.</td><td>Envío de correos transaccionales</td><td>Cláusulas Contractuales Modelo</td></tr>
							<tr><td>Autodesk Inc. (Forge/APS)</td><td>EE.UU.</td><td>Visualización de modelos BIM</td><td>Cláusulas Contractuales Modelo</td></tr>
						</tbody>
					</table>
				</div>
				<p><strong>No vendemos, cedemos ni compartimos datos personales</strong> con terceros con fines comerciales propios.</p>
				<p>Las transferencias a proveedores en EE.UU. se amparan en las <strong>Cláusulas Contractuales Modelo aprobadas por el Ministerio de Economía</strong> (Resolución RAEX202503748, Diario Oficial 19-12-2025), conforme al Art. 27 de la Ley 21.719.</p>
			</section>

			<section class="section" id="retencion">
				<h2>5. Por cuánto tiempo</h2>
				<div class="table-wrap">
					<table class="md-table">
						<thead><tr><th>Dato</th><th>Plazo de retención</th></tr></thead>
						<tbody>
							<tr><td>Datos de cuenta y proyecto</td><td>Mientras dure la relación contractual, más <strong>3 años</strong> tras la baja de cuenta</td></tr>
							<tr><td>Datos de facturación</td><td><strong>7 años</strong> (obligación tributaria, Art. 200 Código Tributario)</td></tr>
							<tr><td>Logs de aplicación (seguridad)</td><td><strong>1 año</strong></td></tr>
							<tr><td>PIN de firma electrónica</td><td>Hasta su revocación, más 3 años</td></tr>
						</tbody>
					</table>
				</div>
				<p>Vencido el plazo, los datos se eliminan o anonimizan de forma segura.</p>
			</section>

			<section class="section" id="tus-derechos">
				<h2>6. Tus derechos</h2>
				<ul>
					<li><strong>Acceso:</strong> obtener una copia de tus datos (gratuito al menos una vez por trimestre).</li>
					<li><strong>Rectificación:</strong> corregir datos inexactos.</li>
					<li><strong>Supresión:</strong> solicitar el borrado de tus datos (siempre que no exista obligación legal de conservarlos).</li>
					<li><strong>Oposición:</strong> oponerte al tratamiento para una finalidad específica.</li>
					<li><strong>Portabilidad:</strong> recibir tus datos en formato estructurado (JSON/CSV).</li>
					<li><strong>Bloqueo:</strong> suspender temporalmente el tratamiento mientras se resuelve una disputa.</li>
					<li><strong>Revocación del consentimiento:</strong> cuando el tratamiento se base en consentimiento, puedes retirarlo en cualquier momento sin coste.</li>
				</ul>
				<p><strong>Cómo ejercerlos:</strong> escríbenos a <a href="mailto:mcereceda@laot.cl">mcereceda@laot.cl</a> indicando el derecho que deseas ejercer y tu identidad. Respondemos en <strong>30 días corridos</strong> (prorrogables una sola vez por 30 días más). La rectificación, supresión y oposición son <strong>siempre gratuitas</strong>.</p>
			</section>

			<section class="section" id="automatizadas">
				<h2>7. Decisiones automatizadas</h2>
				<p>LaOT <strong>no toma decisiones automatizadas con efectos jurídicos o significativos</strong> sobre los titulares. No realizamos perfilado con fines de segmentación comercial propia.</p>
			</section>

			<section class="section" id="seguridad">
				<h2>8. Seguridad</h2>
				<p>Aplicamos medidas técnicas y organizativas proporcionales al riesgo:</p>
				<ul>
					<li>Cifrado en tránsito (TLS/HTTPS).</li>
					<li>Contraseñas almacenadas con hashing bcrypt.</li>
					<li>Segregación de datos por empresa (company_id).</li>
					<li>Control de acceso por roles y capacidades.</li>
					<li>Logs de actividad de la aplicación.</li>
				</ul>
			</section>

			<section class="section" id="cambios">
				<h2>9. Cambios</h2>
				<p>Podemos actualizar esta política. Publicaremos la versión vigente con su fecha en la plataforma. Ante cambios relevantes, notificaremos por correo.</p>
			</section>

			<section class="section" id="reclamos">
				<h2>10. Reclamos</h2>
				<p>Si consideras que tus derechos han sido vulnerados, puedes reclamar ante la <strong>Agencia de Protección de Datos Personales de Chile</strong> una vez que esta entre en funcionamiento (previsto dic-2026), o ante los Tribunales de Justicia.</p>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PrivacyPolicy',
}
</script>

<style scoped>
.privacy-policy {
	padding: 28px 16px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.container {
	max-width: 980px;
	width: 100%;
	background: #fff;
	border-radius: 6px;
	box-shadow: 0 1px 4px rgba(0,0,0,0.04);
	padding: 24px;
}
.policy-header h1 {
	margin: 0 0 6px 0;
	font-size: 28px;
}
.updated {
	margin: 0 0 16px 0;
	color: rgba(0,0,0,0.6);
}
.section {
	margin-bottom: 20px;
}
.section h2 {
	margin: 0 0 10px 0;
	font-size: 18px;
}
.muted {
	color: rgba(0,0,0,0.7);
}
.table-wrap {
	overflow-x: auto;
}
.md-table {
	width: 100%;
	border-collapse: collapse;
	margin: 8px 0 12px 0;
}
.md-table th,
.md-table td {
	border: 1px solid rgba(0,0,0,0.08);
	padding: 10px;
	text-align: left;
	vertical-align: top;
}
.md-table thead th {
	background: #f7f8fa;
}
.md-table tbody tr:nth-child(even) td {
	background: rgba(0,0,0,0.02);
}
.policy-header a,
.container a {
	color: #1976D2;
}
.disclaimer {
	margin-top: 16px;
	padding-top: 12px;
	border-top: 1px solid rgba(0,0,0,0.06);
	color: rgba(0,0,0,0.85);
	font-size: 14px;
}
@media (max-width: 600px) {
	.policy-header h1 { font-size: 22px; }
	.container { padding: 16px; }
}
</style>

